<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">個管追蹤名單</span>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <form-input v-model="vm.SYear" id="SYear" label="學年度" type="number" required></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-select v-model="vm.Semester" id="Semester" label="學期" required>
                    <div is="option" value="u">上</div>
                    <div is="option" value="d">下</div>
                </form-select>
            </div>
            <div class="col-12">
                <form-input v-model="vm.StudentNo" id="StudentNo" label="學號" type="text" :disabled="isedit" student required></form-input>
            </div>
            <div class="col-12">
                <form-date-input v-model="vm.Date" id="Date" label="本次追蹤日期"></form-date-input>
            </div>
            <div class="col-12 healthtrackingDetail">
                一、近來病情追蹤：<br />
                <label>
                    <input v-model="vm.Q1" type="radio" value="有" />有
                </label>
                <label>
                    <input v-model="vm.Q1" type="radio" value="無" />無
                </label>
                繼續追蹤：<input v-model="vm.Q2" type="number" />次/
                <label>
                    <input v-model="vm.Q3" type="radio" value="週" />週
                </label>
                <label>
                    <input v-model="vm.Q3" type="radio" value="月" />月
                </label>
                ，就醫地點：
                <label>
                    <input v-model="vm.Q4" type="radio" value="同上" />同上
                </label>
                <label>
                    <input v-model="vm.Q4" type="radio" value="其他" />其他
                </label>
                <input v-model="vm.Q5" type="text" />醫院
            </div>
            <div class="col-12 healthtrackingDetail">
                <label>
                    <input v-model="vm.Q6" type="radio" value="有" />有
                </label>
                <label>
                    <input v-model="vm.Q6" type="radio" value="無" />無
                </label>
                藥物使用：<input v-model="vm.Q7" type="text" />
            </div>
            <div class="col-12 healthtrackingDetail">
                目前發作頻率：<br />
                <input v-model="vm.Q8" type="number" />次/
                <input v-model="vm.Q9" type="number" />
                <label>
                    <input v-model="vm.Q10" type="radio" value="週" />週
                </label>
                <label>
                    <input v-model="vm.Q10" type="radio" value="月" />月
                </label>
                <label>
                    <input v-model="vm.Q10" type="radio" value="年" />年
                </label>
                <label>
                    <input v-model="vm.Q10" type="radio" value="特定情況才會" />特定情況才會
                </label>
                <label>
                    <input v-model="vm.Q10" type="radio" value="穩定" />穩定
                </label>
            </div>
            <div class="col-12 healthtrackingDetail">
                自覺狀況: <br />
                <label>
                    <input v-model="vm.Q11" type="radio" value="無症狀" />無症狀
                </label>
                <label>
                    <input v-model="vm.Q11" type="radio" value="重度運動時才有症狀" />重度運動時才有症狀
                </label>
                <label>
                    <input v-model="vm.Q11" type="radio" value="中度及輕度運動時有症狀" />中度及輕度運動時有症狀
                </label>
                <label>
                    <input v-model="vm.Q11" type="radio" value="日常生活及輕度運動有症狀" />日常生活及輕度運動有症狀
                </label>
            </div>
            <div class="col-12 healthtrackingDetail">
                二、介紹疾病相關知識及注意事項:<br />
                <label>
                    <input v-model="vm.Q12" type="checkbox" true-value="true" />疾病照顧衛教:疾病介紹、治療方式 (藥物、非藥物)、自我照顧、注意事項、居家照護注意事項。
                </label><br />
                <label>
                    <input v-model="vm.Q13" type="checkbox" true-value="true" />給予衛教單張或手冊，相關訊息網站、資料等。
                </label><br />
                <label>
                    <input v-model="vm.Q14" type="checkbox" true-value="true" />基本身體評估，如:心跳、血壓、血氧，視觸叩聽等。
                </label><br />
                <label>
                    <input v-model="vm.Q15" type="checkbox" true-value="true" />檢驗值異常衛教。
                </label><br />
                <label>
                    <input v-model="vm.Q16" type="checkbox" true-value="true" />情緒、心理支持。
                </label><br />
                <label>
                    <input v-model="vm.Q17" type="checkbox" true-value="true" />適時協助轉介。
                </label><br />
                <label>
                    <input v-model="vm.Q18" type="checkbox" true-value="true" />教導血糖監測儀、注射器等器具使用。
                </label><br />
                <label>
                    <input v-model="vm.Q19" type="checkbox" true-value="true" />其他建議：<input v-model="vm.Q20" type="text" />
                </label>
            </div>
            <div class="col-12 healthtrackingDetail">
                學生評值:<br />
                <label>
                    <input v-model="vm.Q21" type="radio" value="可配合執行" />可配合執行
                </label><br />
                <label>
                    <input v-model="vm.Q21" type="radio" value="不能配合執行" />不能配合執行，原因： <input v-model="vm.Q22" type="text" />
                </label><br />
                <label>
                    <input v-model="vm.Q21" type="radio" value="經校護說明後可了解疾病及相關注意事項" />經校護說明後可了解疾病及相關注意事項
                </label><br />
                <label>
                    <input v-model="vm.Q21" type="radio" value="不了解" />不了解，原因： <input v-model="vm.Q23" type="text" />
                </label>
            </div>
        </div>
        <b-overlay slot="modal-footer" v-if="this.modalkey" :show="adding">
            <b-button variant="info" v-b-modal.modal-center>需後續追蹤</b-button>
            <b-modal id="modal-center" size="sm" centered title="預計隔幾個月進行追蹤" @ok="addtrack" ok-title="儲存" cancel-title="關閉">
                <div class="col-12">
                    <form-select v-model="vm.Q24" id="Q24" label="">
                        <div is="option" value="">請選擇</div>
                        <div is="option" v-for="o in 12" :key="o" :value="o">{{o}} 個月後</div>
                    </form-select>
                </div>
            </b-modal>
        </b-overlay>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'healthtrackingDetail',
        api: '/api/healthtracking/',
        data: {
            adding: false,
        },
        methods: {
            addtrack: function () {
                this.adding = true;
                return this.$http({ method: 'patch', url: 'api/healthtracking/AddTrack', data: this.vm })
                    .then(() => this.$http({ method: 'post', url: 'api/healthtracking/Post', data: this.vm }))
                    .then(() => {
                        this.$bvToast.toast('新增成功', { title: '', variant: 'success', solid: true });
                        this.$emit('reload');
                    })
                    .finally(() => this.adding = false);
            }
        }
    });
</script>

<style>
    .healthtrackingDetail input { border-top: 0; border-right: 0; border-left: 0; }
        .healthtrackingDetail input[type=number] { max-width: 50px; }
</style>